/** @jsx jsx */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { css, jsx } from '@emotion/react';

import MuiMenu from '@material-ui/core/Menu';
import MuiMenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import { useTheme } from '@material-ui/core/styles';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})(props => (
  <MuiMenu
    elevation={0}
    getContentAnchorEl={null}
    autoFocus={false}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    MenuListProps={{
      disablePadding: true,
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    paddingTop: 10,
    paddingBottom: 10,
    '&:hover': {
      backgroundColor: '#08be64',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MuiMenuItem);

const StyledListItemIcon = withStyles(theme => ({
  root: {
    minWidth: 'auto',
    marginRight: 15,
    maxWidth: 27,
  },
}))(ListItemIcon);

const StyledListItemText = withStyles(theme => ({
  primary: {
    fontFamily: 'Montserrat',
    fontSize: '15px',
    letterSpacing: '0.11px',
  },
}))(ListItemText);

export function Menu({ children, menuItems }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderMenuItemContent = ({ icon, iconUrl, iconAlt, text }) => {
    return (
      <>
        {(icon || iconUrl) && (
          <StyledListItemIcon>
            {icon || (
              <img
                src={iconUrl}
                alt={iconAlt}
                css={css`
                  width: 100%;
                `}
              />
            )}
          </StyledListItemIcon>
        )}
        <StyledListItemText primary={text} />
      </>
    );
  };

  const renderMenuItem = ({ icon, iconUrl, iconAlt, text, href, onClick }) => {
    if (onClick) {
      return (
        <StyledMenuItem onClick={() => onClick({ closeMenu: handleClose })}>
          {renderMenuItemContent({ icon, iconUrl, iconAlt, text })}
        </StyledMenuItem>
      );
    }

    return (
      <StyledMenuItem button component="a" href={href}>
        {renderMenuItemContent({ icon, iconUrl, iconAlt, text })}
      </StyledMenuItem>
    );
  };

  return (
    <>
      <span
        css={css`
          cursor: pointer;
        `}
        onClick={handleClick}
      >
        {children}
      </span>
      <StyledMenu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {menuItems.map(({ icon, iconUrl, iconAlt, text, href, onClick }) =>
          renderMenuItem({ icon, iconUrl, iconAlt, text, href, onClick }),
        )}
      </StyledMenu>
    </>
  );
}
